import * as React from 'react';
import Typography from '@mui/material/Typography';
import { getConfigText, newLineParser } from "../utils";

export default function IntoThemaPage({ pageId }) {


    return (
        <React.Fragment>
            {/* <Typography variant="h5" gutterBottom>
                Inleiding
            </Typography> */}

            <Typography variant="body2" gutterBottom style={{ whiteSpace: "pre-line" }}>
                {newLineParser(getConfigText(pageId, "thema_inleiding"))}
            </Typography>

        </React.Fragment>
    );
}
